const IconMobile = (props) => {
  return (
    <svg
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M9.83341 3.33333H11.5001M10.6667 14.1667V14.175M5.66675 4.16667C5.66675 3.72464 5.84234 3.30072 6.1549 2.98816C6.46746 2.67559 6.89139 2.5 7.33341 2.5H14.0001C14.4421 2.5 14.866 2.67559 15.1786 2.98816C15.4912 3.30072 15.6667 3.72464 15.6667 4.16667V15.8333C15.6667 16.2754 15.4912 16.6993 15.1786 17.0118C14.866 17.3244 14.4421 17.5 14.0001 17.5H7.33341C6.89139 17.5 6.46746 17.3244 6.1549 17.0118C5.84234 16.6993 5.66675 16.2754 5.66675 15.8333V4.16667Z'
        stroke='currentColor'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default IconMobile
